import React, { useState } from 'react'
import GateBanner from './GateBanner'

const getBackgroundImage = (imageId, image) => {
  if (imageId) {
    return `${process.env.SITE_ASSET_URL}/${imageId}`
  }
  if (image) {
    return image.url
  }
  return null
}

const YesNoGateBanner = ({ yesNoGate = {}, onYesClick, onNoClick }) => {
  const [showNoScreen, setShowNoScreen] = useState(false)

  const {
    yesNoGateTitle = '',
    yesNoGateNoUrl = '',
    yesNoGateBodyCopy = '',
    yesNoGateYesButtonCopy = '',
    yesNoGateNoButtonCopy = '',
    yesNoGateNoScreenTitle = '',
    yesNoGateNoScreenBodyCopy = '',
    yesNoGateBackgroundImageId = '',
    yesNoGateBackgroundImage = '',
    yesNoGateMobileBackgroundImageId = '',
    yesNoGateMobileBackgroundImage = '',
    yesNoGateNoMobileBackgroundImageId = '',
    yesNoGateNoMobileBackgroundImage = '',
    yesNoGateNoBackgroundImageId = '',
    yesNoGateNoBackgroundImage = '',
    yesNoGateNoScreenButtonCopy = '',
    yesNoGateNoScreenButtonUrl = '',
  } = yesNoGate

  const handleYesClick = () => {
    onYesClick?.()
  }

  const urlRedirect = url => {
    if (url) {
      window.location.href = url
      return
    }
  }

  const handleNoClick = url => {
    onNoClick?.()
    !yesNoGateNoUrl && setShowNoScreen(true)
    urlRedirect(url)
  }

  const handleNoScreenClick = url => {
    urlRedirect(url)
  }

  const backgroundImageId = showNoScreen
    ? yesNoGateNoBackgroundImageId
    : yesNoGateBackgroundImageId

  const backgroundImage = showNoScreen
    ? yesNoGateNoBackgroundImage
    : yesNoGateBackgroundImage

  const mobileBackgroundImageId = showNoScreen
    ? yesNoGateNoMobileBackgroundImageId
    : yesNoGateMobileBackgroundImageId

  const mobileBackgroundImage = showNoScreen
    ? yesNoGateNoMobileBackgroundImage
    : yesNoGateMobileBackgroundImage

  const buttons = !showNoScreen ? (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
      <a onClick={handleYesClick} className="btn herobtn themed-button">
        {yesNoGateYesButtonCopy}
      </a>
      <a
        onClick={() => handleNoClick(yesNoGateNoUrl)}
        className="btn herobtn themed-button"
      >
        {yesNoGateNoButtonCopy}
      </a>
    </div>
  ) : yesNoGateNoScreenButtonCopy ? (
    <a
      onClick={() => handleNoScreenClick(yesNoGateNoScreenButtonUrl)}
      className="btn herobtn themed-button"
    >
      {yesNoGateNoScreenButtonCopy}
    </a>
  ) : null

  return (
    <>
      <GateBanner
        title={!showNoScreen ? yesNoGateTitle : yesNoGateNoScreenTitle}
        text={!showNoScreen ? yesNoGateBodyCopy : yesNoGateNoScreenBodyCopy}
        backgroundImageUrl={getBackgroundImage(
          backgroundImageId,
          backgroundImage,
        )}
        mobileBackgroundImageUrl={getBackgroundImage(
          mobileBackgroundImageId,
          mobileBackgroundImage,
        )}
        button={buttons}
      />
    </>
  )
}

export default YesNoGateBanner
